import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  Button,
} from 'components';

import { formatLogin } from 'utils/formatString';

import { USER_TYPES } from '../../constants';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const isFttb = (type) => type === USER_TYPES.FTTB;

const IncomingLinkageRequest = ({
  destinationName,
  isCanceling,
  cancelRequest,
  messageText,
  cancelRequestText,
  destinationType,
}) => (
  <DataBlocks.TableRow>
    <DataBlocks.TableCell
      className={cx('cell')}
      colSpan="10"
    >
      <div className={cx('request')}>
        <div className={cx('login')}>
          {formatLogin(destinationName, isFttb(destinationType))}
        </div>
        <div className={cx('message')}>
          {messageText}
        </div>
        <div className={cx('button')}>
          <Button
            className="default"
            isLoading={isCanceling}
            onClick={() => cancelRequest(destinationName)}
          >
            {cancelRequestText}
          </Button>
        </div>
      </div>
    </DataBlocks.TableCell>
  </DataBlocks.TableRow>
);

IncomingLinkageRequest.propTypes = {
  destinationName: PropTypes.string,
  destinationType: PropTypes.string,
  isCanceling: PropTypes.bool,
  cancelRequest: PropTypes.func,
  messageText: PropTypes.any,
  cancelRequestText: PropTypes.any,
};

export default IncomingLinkageRequest;
